export enum FormType {
    Download = 'download',
    Contact = 'contact',
    Supplier = 'supplier',
    AskRose = 'ask_rose',
    RFP = 'rfp',
    Event = 'event'
}

export enum FormTriggerStyle {
    BUTTON = 'button',
    LIST = 'list',
    CARD = 'card'
}